import { render, staticRenderFns } from "./OpIsNotIcon.vue?vue&type=template&id=229585bb&scoped=true"
import script from "./OpIsNotIcon.vue?vue&type=script&lang=js"
export * from "./OpIsNotIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229585bb",
  null
  
)

export default component.exports